import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-LdapAuth',
    templateUrl: './LdapAuth.component.html'
})
export class LdapAuthComponent implements OnInit {

    consumerID: string;
    ldap_host: string;
    ldap_port: number;
    start_tls: boolean;
    verify_ldap_host: boolean;
    base_dn: string;
    attribute: string;
    cache_ttl = 60;
    hide_credentials = false;
    timeout = 10000;
    keepalive = 60000;
    anonymous: string;
    header_type = 'ldap';

    data = {
        'consumerID': this.consumerID,
        'ldap_host': this.ldap_host,
        'ldap_port': this.ldap_port,
        'start_tls': this.start_tls,
        'verify_ldap_host': this.verify_ldap_host,
        'base_dn': this.base_dn,
        'attribute': this.attribute,
        'cache_ttl': this.cache_ttl,
        'hide_credentials': this.hide_credentials,
        'timeout': this.timeout,
        'keepalive': this.keepalive,
        'anonymous': this.anonymous,
        'header_type': this.header_type,
        'plugin': 'ldap-auth'
    }


    constructor() { }
    slider() {
        this.start_tls = !this.start_tls;
    }
    slider1() {
        this.verify_ldap_host = !this.verify_ldap_host;
    }
    slider2() {
        this.hide_credentials = !this.hide_credentials;
    }

    LdapAuth(){
    }
    ngOnInit() {
    }

}
